<ul class="nav nav-tabs">
    <li routerLinkActive="active"><a class="seguro" [routerLink]="['/seguro']">Mi <strong>Seguro</strong></a></li>
    <li routerLinkActive="active"><a class="viajes" [routerLink]="['/viajes']">Mis <strong>Viajes</strong></a></li>
    <li routerLinkActive="active"><a class="eventos" [routerLink]="['/eventos']">Mis <strong>Eventos</strong></a></li>
    <li routerLinkActive="active"><a class="auto" [routerLink]="['/auto']">Mi <strong>Auto</strong></a></li>
    <li style="visibility:hidden;"><a class="tendencias" href="#menu3">Mis <strong>Tendencias</strong></a></li>
    <li style="visibility:hidden;"><a class="ajustes" href="#menu5">Mis <strong>Ajustes</strong></a></li>
</ul>
